// extracted by mini-css-extract-plugin
export default {"fields":"Settings_fields_wBeLK","field":"Settings_field_BhmEI","label":"Settings_label_BGnrK","legend":"Settings_legend_oCUg9"};